import ImageOptimizer from '@/components/image-optimizer';
import { StoreEntity } from '@/services/types/store.type';
import Link from 'next/link';
import CommonBranchCarousel from './common-branch-carousel';

interface CommonBranchListProps {
  branches: StoreEntity[];
  addTitle: string;
}

export default function CommonBranchList({
  branches,
  addTitle,
}: CommonBranchListProps) {
  return (
    <div className="desktop:mt-[120px] mt-[100px] flex flex-col items-center justify-center">
      {/**웹 */}
      <div className="desktop:block desktop:w-[285px] desktop:h-[86px] relative hidden">
        <ImageOptimizer
          src="/images/recommend-class/unlimited/store_comment.svg"
          alt="curriculum top"
          fill
          className="object-contain"
        />
      </div>
      <div className="desktop:typo-40 typo-28 text-level-1 desktop:mt-[32px] desktop:block hidden font-semibold">
        <span className="font-extrabold">가까운 드라이빙존</span>에서 {addTitle}
      </div>
      {/** -- 웹 */}
      {/**모바일 */}
      <div className="desktop:hidden relative h-[54px] w-[185px]">
        <ImageOptimizer
          src="/images/recommend-class/unlimited/store_comment_mo.svg"
          alt="curriculum top"
          fill
          className="object-contain"
        />
      </div>
      <div className="desktop:hidden typo-28 text-level-1 mt-[16px] text-center leading-snug font-semibold">
        <span className="font-extrabold">가까운 드라이빙존</span>에서
        <br />
        {addTitle}
      </div>
      {/** -- 모바일 */}

      <div className="desktop:my-20 mt-8 w-full">
        <CommonBranchCarousel branches={branches} />
      </div>

      <Link href="/branch" className="cursor-pointer">
        {/**웹 */}
        <ImageOptimizer
          src="/images/recommend-class/common/place_btn.svg"
          alt="더 많은 지점 보러가기 버튼"
          width={424}
          height={104}
          className="desktop:block mt-[26px] hidden"
        />
        {/** 모바일 */}
        <ImageOptimizer
          src="/images/recommend-class/common/mo_place_btn.svg"
          alt="더 많은 지점 보러가기 버튼"
          width={280}
          height={80}
          className="desktop:hidden mt-15"
        />
      </Link>
    </div>
  );
}
